<template>
  <div>
    <mobileConsult />
    <consult />
    <toTop class="to-top" />
    <div class="about-wrapper01">
      <div class="text01">因为专注，所以专业。</div>
    </div>

    <section class="index_company_profile">
      <h1>公司简介</h1>
      <p>邮鸽网络——出行行业数字化解决方案服务商</p>
      <div>杭州邮鸽网络科技有限公司是⼀家提供一站式出行行业数字化解决方案服务商，母公司成立于1995年，专注于网约车和出租车业务，构建了出行行业的运力运营生态系统——爱开.IDrive。目前已与多家出行平台和出租车公司合作，共同开展业务项目。公司以杭州为中心，辐射全国各地的出行市场，为企业级用户和从业司机提供个性化优质服务。</div>
      <div>公司定位为出行行业数字化解决方案服务商，拥有超过 20 年出行行业经验，凭借丰富的行业经验和技术实力，为行业提供全方位的数字化解决方案。公司已获得超过 30 项软件著作权，体现了公司在技术研发和创新方面的突出能力。同时，公司基于超过 10 年的技术沉淀，不断优化产品和服务，以满足客户日益增长的需求。</div>
      <div>公司拥有第二类增值电信业务、互联网信息服务、网络预约出租汽车经营服务等许可项目，为公司的业务发展提供了有力的支持。此外，公司对外投资 18 家公司，拥有 62 处分支机构，彰显了公司的实力和影响力。</div>
      <div>总之，杭州邮鸽网络科技有限公司凭借其在技术研发、信息化建设和市场拓展方面的优势，正逐步成为出行行业的佼佼者，致力于打造全国一流的出行行业数字化解决方案服务商。</div>
    </section>

    <!-- pc 联系我们 start -->
    <section class="index_contact_us">
      <h1>联系我们</h1>
      <div class="contact_us_wrapper">
        <div class="contact_main">
          <div class="item_wrapper">
            <div>
              <img  src="../assets/images/aboutus02.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
            </div>
            <div>
              <div>杭州邮鸽网络科技有限公司</div>
              <div>地址：杭州市拱墅区滨江星城发展大厦2幢4楼</div>
            </div>
          </div>
          <!-- <div class="item_wrapper">
            <div>
              <img  src="../assets/images/aboutus03.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
            </div>
            <div>
              <div>售前咨询</div>
              <div>400-800-5571</div>
            </div>
          </div> -->
          <!-- <div class="item_wrapper">
            <div>
              <img  src="../assets/images/aboutus03.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
            </div>
            <div>
              <div>咨询电话</div>
              <div>153-4581-0586</div>
            </div>
          </div> -->
          <div class="item_wrapper">
            <div>
              <img  src="../assets/images/aboutus05.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
            </div>
            <div>
              <div>市场&商务合作</div>
              <div>mkt@yoogonet.com</div>
            </div>
          </div>
        </div>
        <div><img class="map" src="../assets/images/aboutus01.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型"></div>
      </div>
    </section>
    <!-- pc 联系我们 end-->

    <!-- mobile  联系我们 start -->
    <section class="mobile_contact_us">
      <h1>联系我们</h1>
      <div class="contact_us_wrapper">
        <div class="contact_main">
          <div class="item_wrapper">
            <div>
              <img  src="../assets/images/aboutus02.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
            </div>
            <div>
              <div>杭州邮鸽网络科技有限公司</div>
              <div>地址：杭州市拱墅区滨江星城发展大厦2幢4楼</div>
            </div>
          </div>
          <!-- <div class="item_wrapper">
            <div>
              <img  src="../assets/images/aboutus03.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
            </div>
            <div>
              <div>售前咨询</div>
              <div>400-800-5571</div>
            </div>
          </div> -->
          <!-- <div class="item_wrapper">
            <div>
              <img  src="../assets/images/aboutus03.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
            </div>
            <div>
              <div>咨询电话</div>
              <div>153-4581-0586</div>
            </div>
          </div> -->
          <div class="item_wrapper">
            <div>
              <img  src="../assets/images/aboutus05.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
            </div>
            <div>
              <div>市场&商务合作</div>
              <div>mkt@yoogonet.com</div>
            </div>
          </div>
        </div>
        <div class="map_wrapper"><img class="map" src="../assets/images/aboutus01.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型"></div>
      </div>
    </section>
    <!-- mobile 联系我们 end-->
  </div>
</template>
 
<script>
import consult from '../components/consult.vue'
import mobileConsult from '../components/mobileConsult.vue'
import toTop from '../components/toTop.vue'

 
export default {
  name: 'aboutus',
  components:{
    toTop,
    consult,
    mobileConsult
  },
  data() {
    return {
      
    };
  },
  mounted(){
	
  }
};
</script>
 
<style lang='scss' scoped>
.about-wrapper01{
  width: 100%;
  height: 35.41667rem;
  background: url('https://yoogurt.oss-cn-hangzhou.aliyuncs.com/bbc/aboutus-bg01.png');
  background-size: cover;
  .text01{
    color: rgb(0, 105, 234);
    font-family: PingFang SC;
    font-size: $fontSize45;
    font-weight: 500;
    padding-left: 20rem;
    padding-top: 7.4rem;
  }
}

.index_company_profile{
  width: 58.75rem;
  margin: 0 auto;
  h1{
    text-align: center;
    font-size: $fontSize45;
    font-weight: 500;
    margin-top: 4.4rem;
    margin-bottom: $fontSize32;
  }
  p{
    text-align: center;
    font-size: $fontSize18;
    margin-bottom: $fontSize32;
  }
  div{
    text-indent: $fontSize36;
    font-size: $fontSize18;
    margin-bottom: $fontSize24;
  }
}

.mobile_contact_us{
  display: none;
}
.index_contact_us{
  width: 58.75rem;
  margin: 0 auto;
  
  h1{
    text-align: center;
    font-size: $fontSize45;
    font-weight: 500;
    margin-top: 4.4rem;
    margin-bottom: $fontSize32;
  }
  .contact_us_wrapper{
    display: flex;
    justify-content: space-between;
    padding: 2rem 0;
    .contact_main{
      height: 23.85417rem;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .item_wrapper{
        display: flex;
        align-items: center;
        font-size: $fontSize18;
      }
    }
    .map{
      width: 30.625rem;
      height: 23.85417rem;
      
    }
  }
}
       
// 移动端
@media screen and (min-width: 300px) and (max-width: 768px) {
  .to-top{
    display: none;
  }
  .about-wrapper01{
    width: 100%;
    height: 35.41667rem;
    background: url('https://yoogurt.oss-cn-hangzhou.aliyuncs.com/bbc/aboutus-bg01.png');
    background-size: cover;
    .text01{
      color: rgb(0, 105, 234);
      font-family: PingFang SC;
      font-size: $mFontSize20;
      font-weight: 500;
      padding-left: 3rem;
      padding-top: 7.4rem;
    }
  } 

  .index_company_profile{
    width: 100%;
    padding: 0 3rem;
    h1{
      text-align: center;
      font-size: $mFontSize20;
      font-weight: 500;
      margin-top: $mFontSize20;
      margin-bottom: $mFontSize12;
    }
    p{
      text-align: center;
      font-size: $mFontSize12;
      margin-bottom: $fontSize32;
    }
    div{
      text-indent: $mFontSize20;
      font-size: $mFontSize12;
      margin-bottom: $mFontSize12;
    }
  }

  .index_contact_us{
    display: none;
  }
  .mobile_contact_us{
    display: block;
    h1{
      text-align: center;
      font-size: $mFontSize20;
      font-weight: 500;
      margin-top: $mFontSize20;
      margin-bottom: $mFontSize12;
    }
    .contact_us_wrapper{
      display: flex;
      flex-direction: column;
      .contact_main{
        
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .item_wrapper{
          display: flex;
          align-items: center;
          font-size: $mFontSize12;
        }
      }
      .map_wrapper{
        width: 100%;
        text-align: center;
        margin-bottom: 10rem;
        .map{
          width: 90rem;
          height: 60rem;
        }
      }
      
    }
  }
        
}
 
</style>